import React from 'react';
import { X } from 'lucide-react';

const InvoicePopup = ({ invoice, onClose }) => {
  if (!invoice) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl p-8 max-w-2xl w-full relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
        >
          <X size={24} />
        </button>
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Invoice Details</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm text-gray-500">Invoice Number</p>
            <p className="font-semibold text-gray-800">{invoice.invoice_number}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Payment ID</p>
            <p className="font-semibold text-gray-800">{invoice.razorpay_payment_id}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Subscription ID</p>
            <p className="font-semibold text-gray-800">{invoice.razorpay_subscription_id}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Plan</p>
            <p className="font-semibold text-gray-800">{invoice.plan_name}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Status</p>
            <p className="font-semibold text-green-600 capitalize">{invoice.status}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Payer Email</p>
            <p className="font-semibold text-gray-800">{invoice.payer_email}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Invoice Date</p>
            <p className="font-semibold text-gray-800">
              {new Date(invoice.invoice_date).toLocaleDateString()}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Due Date</p>
            <p className="font-semibold text-gray-800">
              {new Date(invoice.due_date).toLocaleDateString()}
            </p>
          </div>
        </div>
        <div className="mt-8 border-t pt-6">
          <div className="flex justify-end">
            <div className="w-1/2">
              <div className="flex justify-between">
                <p className="text-sm text-gray-500">Subtotal</p>
                <p className="font-semibold text-gray-800">${(invoice.subtotal / 100).toFixed(2)}</p>
              </div>
              <div className="flex justify-between mt-2">
                <p className="text-sm text-gray-500">Tax</p>
                <p className="font-semibold text-gray-800">${(invoice.tax_amount / 100).toFixed(2)}</p>
              </div>
              <div className="flex justify-between mt-4 pt-4 border-t">
                <p className="text-lg font-bold text-gray-800">Total</p>
                <p className="text-lg font-bold text-gray-800">${(invoice.total / 100).toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t pt-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Line Items</h3>
          {invoice.line_items.map((item, index) => (
            <div key={index} className="flex justify-between items-center mb-2">
              <div>
                <p className="font-semibold text-gray-800">{item.name}</p>
                <p className="text-sm text-gray-500">{item.description}</p>
              </div>
              <p className="font-semibold text-gray-800">
                ${(item.amount / 100).toFixed(2)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InvoicePopup;
